export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const TOKEN_KEY = "buscema_history_token";
